export const en = {
    nav: {
        dashboard: 'Dashboard',
        board: 'Board',
        list: 'List',
        settings: 'Settings',
        reports: 'Reports',
        myTasks: 'My Tasks',
        activity: 'Activity',
        charts: 'Charts',
        team: 'Team',
        timeTracking: 'Time Tracking',
        admin: 'Admin',
        adminOverview: 'Admin Overview',
        userManagement: 'User Management',
        projectSetup: 'Project Setup',
        overview: 'Overview',
        changeLog: 'Change Log',
    },
    common: {
        projectManMD: 'ProjectManMD',
        markdownProjectManagement: 'Markdown Project Management',
        version: 'Version',
        back: 'Back',
        loading: 'Loading...',
        noData: 'No data',
        search: 'Search',
        filter: 'Filter',
        all: 'All',
        close: 'Close',
        open: 'Open',
        connect: 'Connect',
        archived: 'Archived',
        inactive: 'Inactive',
        active: 'Active',
        untitled: 'Untitled',
        unknown: 'Unknown',
        tasks: 'Tasks',
        done: 'Done',
        lastModified: 'Last modified',
        created: 'Created',
        points: 'Points',
        pts: 'pts',
        yes: 'Yes',
        no: 'No',
        or: 'or',
    },
    actions: {
        create: 'Create',
        edit: 'Edit',
        delete: 'Delete',
        save: 'Save',
        cancel: 'Cancel',
        confirm: 'Confirm',
        add: 'Add',
        remove: 'Remove',
        update: 'Update',
        close: 'Close',
        submit: 'Submit',
        reset: 'Reset',
        load: 'Load',
        export: 'Export',
        import: 'Import',
        archive: 'Archive',
        restore: 'Restore',
        deactivate: 'Deactivate',
        activate: 'Activate',
    },
    auth: {
        signIn: 'Sign In',
        signOut: 'Sign Out',
        signUp: 'Sign Up',
        username: 'Username',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        displayName: 'Display Name',
        email: 'Email',
        role: 'Role',
        createAccount: 'Create Account',
        dontHaveAccount: "Don't have an account?",
        alreadyHaveAccount: 'Already have an account?',
        signInToAccount: 'Sign in to your account',
        createYourAccount: 'Create your account',
        enterUsername: 'Enter your username',
        enterPassword: 'Enter your password',
        chooseUsername: 'Choose a username',
        yourFullName: 'Your full name',
        atLeast6Chars: 'At least 6 characters',
        confirmPasswordPlaceholder: 'Confirm your password',
        pleaseEnterCredentials: 'Please enter username and password',
        invalidCredentials: 'Invalid username or password',
        pleaseFillAllFields: 'Please fill in all fields',
        passwordsDoNotMatch: 'Passwords do not match',
        passwordTooShort: 'Password must be at least 6 characters',
        usernameExists: 'Username already exists',
        demoCredentials: 'Demo credentials',
        admin: 'Admin',
        manager: 'Manager',
        developer: 'Developer',
        viewer: 'Viewer',
        contactAdminForRole: 'Contact admin to change role',
        usernameCannotBeChanged: 'Username cannot be changed',
    },
    statuses: {
        backlog: 'Backlog',
        todo: 'To Do',
        inProgress: 'In Progress',
        inReview: 'In Review',
        done: 'Done',
        planned: 'Planned',
        inProgressSprint: 'In Progress (Sprint)',
        completed: 'Completed',
        allStatus: 'All Status',
    },
    priorities: {
        critical: 'Critical',
        high: 'High',
        medium: 'Medium',
        low: 'Low',
    },
    messages: {
        noProjects: 'No projects yet',
        noTasks: 'No tasks',
        confirmDelete: 'Are you sure you want to delete this?',
        saved: 'Saved successfully',
        error: 'An error occurred',
        noTasksAssigned: 'No tasks assigned to you',
        noActivityYet: 'No activity yet',
        confirmReset: 'This will reset all data to seed state. Continue?',
        removeUserConfirm: 'Are you sure you want to remove this user?',
        deleteProjectConfirm: 'Are you sure you want to delete this project?',
        archiveProjectConfirm: 'Are you sure you want to archive this project?',
    },
    settings: {
        title: 'Settings',
        theme: 'Theme',
        language: 'Language',
        languageAndRegion: 'Language & Region',
        gitConfig: 'Git Configuration',
        gitIntegration: 'Git Integration',
        gitProvider: 'Git Provider',
        repositoryUrl: 'Repository URL',
        seedData: 'Seed Data',
        seedDataDescription: 'Load sample projects with tasks, sprints, and epics for testing. This will reset all data to the seed state.',
        loadSeedData: 'Load Seed Data',
        seedDataConfirm: 'This will reset all data to seed state. Continue?',
        appearance: 'Appearance',
        notifications: 'Notifications',
    },
    themes: {
        summer: 'Summer',
        spring: 'Spring',
        autumn: 'Autumn',
        winter: 'Winter',
        day: 'Day',
        night: 'Night',
        summerDay: 'Summer Day',
        summerNight: 'Summer Night',
        springDay: 'Spring Day',
        springNight: 'Spring Night',
        autumnDay: 'Autumn Day',
        autumnNight: 'Autumn Night',
        winterDay: 'Winter Day',
        winterNight: 'Winter Night',
        highContrast: 'High Contrast',
        selectTheme: 'Select theme',
    },
    time: {
        hours: 'hours',
        minutes: 'minutes',
        days: 'days',
        weeks: 'weeks',
        justNow: 'just now',
        minutesAgo: '{{count}}m ago',
        hoursAgo: '{{count}}h ago',
        daysAgo: '{{count}}d ago',
        updatedAt: 'Updated',
    },
    reports: {
        velocity: 'Velocity',
        burndown: 'Burndown',
        burnup: 'Burnup',
        cycleTime: 'Cycle Time',
        leadTime: 'Lead Time',
        throughput: 'Throughput',
        gantt: 'Gantt',
        cumulativeFlow: 'Cumulative Flow',
    },
    globalSearch: {
        placeholder: 'Search projects, tasks, sprints...',
        noResults: 'No results found',
        projects: 'Projects',
        tasks: 'Tasks',
        sprints: 'Sprints',
        epics: 'Epics',
    },
    notifications: {
        title: 'Notifications',
        markAllRead: 'Mark all as read',
        clearAll: 'Clear all',
        empty: 'No notifications',
        unread: '{count} unread',
    },
    dashboard: {
        totalProjects: 'Total Projects',
        totalTasks: 'Total Tasks',
        completion: 'Completion',
        statusBreakdown: 'Status Breakdown',
        createProject: 'Create Project',
        loadSeedData: 'Load Sample Data',
        noProjects: 'No projects yet',
        getStarted: 'Get started by creating a new project or loading sample data.',
        projects: 'Projects',
        newProject: 'New Project',
        createNewProject: 'Create New Project',
        projectName: 'Project Name',
        description: 'Description',
        workflow: 'Workflow',
        skipToMain: 'Skip to main content',
        projectProgress: 'Project Progress',
        quickActions: 'Quick Actions',
        manageTasks: 'Manage tasks and track progress',
        trackTime: 'Track time for your tasks',
    },
    calendar: {
        jalali: 'Jalali',
        hijri: 'Hijri',
        gregorian: 'Gregorian',
    },
    accessibility: {
        skipToMain: 'Skip to main content',
        board: 'Task board',
        projectList: 'Project list',
        mainNav: 'Main navigation',
        selectTheme: 'Select theme',
        projectDashboard: 'Project dashboard',
        toggleSidebar: 'Toggle sidebar',
    },
    board: {
        title: 'Board',
        kanban: 'Kanban',
        scrum: 'Scrum',
    },
    task: {
        title: 'Task',
        createTask: 'Create Task',
        editTask: 'Edit Task',
        deleteTask: 'Delete Task',
        assignee: 'Assignee',
        unassigned: 'Unassigned',
        storyPoints: 'Story Points',
        labels: 'Labels',
        description: 'Description',
        acceptanceCriteria: 'Acceptance Criteria',
        timeLog: 'Time Log',
        comments: 'Comments',
        addComment: 'Add Comment',
        noComments: 'No comments yet',
        status: 'Status',
        priority: 'Priority',
        created: 'Created',
        updated: 'Updated',
        started: 'Started',
    },
    sprint: {
        title: 'Sprint',
        createSprint: 'Create Sprint',
        sprintGoal: 'Sprint Goal',
        committedPoints: 'Committed Points',
        completedPoints: 'Completed Points',
        velocity: 'Velocity',
        planned: 'Planned',
        inProgress: 'In Progress',
        completed: 'Completed',
    },
    team: {
        title: 'Team',
        members: 'Members',
        role: 'Role',
        availability: 'Availability',
        assignedTasks: 'Assigned Tasks',
        activeTasks: 'Active Tasks',
        doneTasks: 'Done Tasks',
    },
    timeTracking: {
        title: 'Time Tracking',
        timer: 'Timer',
        manualEntry: 'Manual Entry',
        startTime: 'Start Time',
        stopTime: 'Stop Time',
        duration: 'Duration',
        date: 'Date',
        totalHours: 'Total Hours',
        entries: 'Entries',
        noEntries: 'No entries yet',
        hours: 'Hours',
        minutes: 'Minutes',
    },
    admin: {
        dashboard: 'Admin Dashboard',
        projects: 'Projects',
        totalTasks: 'Total Tasks',
        storyPoints: 'Story Points',
        taskStatusBreakdown: 'Task Status Breakdown',
        projectProgress: 'Project Progress',
        teamWorkload: 'Team Workload',
        assigned: 'Assigned',
        active: 'Active',
    },
    myTasks: {
        title: 'My Tasks',
        total: 'Total',
        inProgress: 'In Progress',
        inReview: 'In Review',
        done: 'Done',
        completion: 'Completion',
        allStatus: 'All Status',
        allProjects: 'All Projects',
        noTasksAssigned: 'No tasks assigned to you',
    },
    activity: {
        title: 'Activity Feed',
        commentsOnYourTasks: 'Comments on Your Tasks',
        allActivity: 'All Activity',
        noActivityYet: 'No activity yet',
        commentedOn: 'commented on',
        movedTo: 'moved to',
    },
    profile: {
        title: 'Profile',
        avatar: 'Avatar',
        dragDropImage: 'Drag and drop an image here, or browse files',
        browse: 'Browse',
        imageFormats: 'PNG, JPG, WEBP up to 2 MB',
        removePhoto: 'Remove Photo',
        saveChanges: 'Save Changes',
        profileSaved: 'Profile saved',
        contactAdmin: 'Contact admin for role changes',
    },
    overview: {
        title: 'Project Overview',
        editor: 'Editor',
        preview: 'Preview',
        placeholder: 'Write your project overview in markdown...',
        saved: 'Overview saved successfully',
    },
    teamManagement: {
        title: 'Team Management',
        addMember: 'Add Member',
        addFromUsers: 'From Existing Users',
        addCustom: 'Custom Member',
        editMember: 'Edit Member',
        removeMember: 'Remove Member',
        selectUser: 'Select a user',
        customMember: 'Custom Member',
        name: 'Name',
        role: 'Role',
        username: 'Username',
        availability: 'Availability',
        wipLimit: 'WIP Limit',
        noMembers: 'No team members yet',
        memberAdded: 'Member added successfully',
        memberUpdated: 'Member updated successfully',
        memberRemoved: 'Member removed successfully',
        confirmRemove: 'Are you sure you want to remove this team member?',
    },
    changeLog: {
        title: 'Change Log',
        addEntry: 'Add Entry',
        action: 'Action',
        target: 'Target',
        details: 'Details',
        timestamp: 'Timestamp',
        user: 'User',
        filters: 'Filters',
        dateRange: 'Date Range',
        startDate: 'Start Date',
        endDate: 'End Date',
        actionType: 'Action Type',
        allUsers: 'All Users',
        allActions: 'All Actions',
        noEntries: 'No change log entries yet',
        entryAdded: 'Entry added successfully',
        pageOf: 'Page {{page}} of {{total}}',
        previous: 'Previous',
        next: 'Next',
        actionTypes: {
            projectCreated: 'Project Created',
            taskCreated: 'Task Created',
            statusChange: 'Status Change',
            taskAssigned: 'Task Assigned',
            taskDeleted: 'Task Deleted',
            sprintCreated: 'Sprint Created',
            sprintCompleted: 'Sprint Completed',
            timeLog: 'Time Log',
            manual: 'Manual',
        },
    },
};
//# sourceMappingURL=en.js.map